const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIconPersonaagregar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.9 21.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#202832;}.cls-2{stroke:#202832;stroke-width:0.42px;}")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.08,11.22a5.61,5.61,0,1,1,5.54-5.61A5.59,5.59,0,0,1,10.08,11.22ZM10.08,1a4.54,4.54,0,0,0-4.5,4.57,4.5,4.5,0,1,0,9,0A4.54,4.54,0,0,0,10.08,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.08,10.53A10.16,10.16,0,0,0,0,20.75H1a9.12,9.12,0,0,1,9-9.18,9,9,0,0,1,7.62,4.26h1.21A10.08,10.08,0,0,0,10.08,10.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.39,19.25v-.69h1.8V16.74h.7v1.82h1.8v.69h-1.8v1.81h-.7V19.25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonaagregar);
export default __webpack_public_path__ + "static/media/Icon_persona agregar.29940e1f60a79fd0406624c26849c65a.svg";
export { ForwardRef as ReactComponent };